import api from './client'

/**
 * Maestro BANCOS de Presea (espejo de BANCOS_LGR.DBI). Solo lectura — se
 * sincroniza por el cron `presea:sincronizar-maestros`.
 * Tipos de valor (TIPOVALOR):
 *   1 = CHEQUE   ·   4 = TARJETA / pasarela
 *   7 = EFECTIVO ·   8 = TRANSFERENCIA
 *   (otros tipos menos usados: 9, 10, 12, 15, 20)
 */
export const bancosApi = {
  list: ({ tipo, q, limit } = {}) =>
    api.get('/bancos', { params: { tipo, q, limit } }),
}

export const TIPOVALOR = {
  CHEQUE: 1,
  TARJETA: 4,
  EFECTIVO: 7,
  TRANSFERENCIA: 8,
}

export const TIPOVALOR_LABEL = {
  1: 'Cheque',
  4: 'Tarjeta / Pasarela',
  7: 'Efectivo',
  8: 'Transferencia',
  9: 'Caja de ahorro',
  10: 'Millas',
  12: 'Plazo fijo',
  15: 'Gift card',
  20: 'Canjes',
}
